import { useState } from "react";

export const useSendMessage = ({ conversation }) => {
    const [sending, setSending] = useState(false);
    const [messageBody, setMessageBody] = useState('');

    const handleSendMessage = async () => {
        if (!conversation || sending || !messageBody || messageBody === '') {
            return;
        }
        setSending(true);

        try {
            const messageBuilder = conversation.prepareMessage();

            messageBuilder.setBody(messageBody);

            await messageBuilder.build().send();

            setMessageBody('');
            conversation.setAllMessagesRead();
        } catch (e) {
            alert("Have errors while sending message");
        }
        setSending(false);
    };

    return { sending, messageBody, setMessageBody, handleSendMessage };
};
